import { crudActions } from '../factories'

export const { find, setList, clearList, get, save, remove } = crudActions({ name: 'libraryDailyContents' })
